import m from "./index266.js";
import { resolveComponent as a, createElementBlock as o, openBlock as r, createElementVNode as s, createBlock as c, createVNode as d, normalizeClass as i, Fragment as b, renderList as h, toDisplayString as g } from "vue";
import f from "./index231.js";
const _ = ["data-component"], k = { class: "flex items-center justify-center" }, w = { class: "mr-auto" }, C = ["disabled"], y = {
  key: 0,
  class: "flex group"
}, $ = ["aria-label", "aria-current", "onClick"], v = { class: "text-h4" }, S = { class: "ml-auto" }, L = ["disabled"], P = {
  key: 0,
  class: "flex group"
};
function B(e, n, F, N, V, j) {
  const u = a("ms-arrow-left"), l = a("ms-arrow"), p = a("ms-arrow-right");
  return r(), o("nav", {
    "data-component": e.$options.name,
    "aria-label": "Seitennavigation",
    class: "text-h4"
  }, [
    s("ul", k, [
      s("li", w, [
        s("button", {
          "aria-label": "Vorherige Seite",
          disabled: e.isFirstPage,
          class: "disabled:text-color-greyscale-200 disabled:[-webkit-text-fill-color:inherit]",
          type: "button",
          onClick: n[0] || (n[0] = (t) => e.pageClick(e.$props.current - 1))
        }, [
          e.isScreenM ? (r(), o("span", y, [
            d(u, { class: "w-24 h-24 mr-8" }),
            s("span", {
              class: i(["font-bold text-h4", { "group-hover:underline": !e.isFirstPage }])
            }, "Zurück", 2)
          ])) : (r(), c(l, {
            key: 1,
            class: "w-24 h-24 transform rotate-180"
          }))
        ], 8, C)
      ]),
      (r(!0), o(b, null, h(e.pages, (t) => (r(), o("li", {
        key: t.page
      }, [
        s("button", {
          "aria-label": t.ariaLabel,
          "aria-current": t.isCurrent ? "true" : void 0,
          class: i(["flex items-center justify-center mr-8 rounded-normal w-52 h-52", {
            "hover:bg-color-brand-beige-100 focus:bg-color-brand-beige-100 ": !t.isCurrent,
            "bg-anthracite text-white": t.isCurrent,
            "mr-0": t.page == e.pages.length
          }]),
          type: "button",
          onClick: (x) => !t.isCurrent && e.pageClick(t.page)
        }, [
          s("span", v, g(t.page), 1)
        ], 10, $)
      ]))), 128)),
      s("li", S, [
        s("button", {
          class: "disabled:text-color-greyscale-200 disabled:[-webkit-text-fill-color:inherit]",
          "aria-label": "Nächste Seite",
          disabled: e.isLastPage,
          type: "button",
          onClick: n[1] || (n[1] = (t) => e.pageClick(e.$props.current + 1))
        }, [
          e.isScreenM ? (r(), o("span", P, [
            s("span", {
              class: i(["font-bold text-h4", { "group-hover:underline": !e.isLastPage }])
            }, "Weiter", 2),
            d(p, { class: "w-24 h-24 ml-8" })
          ])) : (r(), c(l, {
            key: 1,
            class: "w-24 h-24"
          }))
        ], 8, L)
      ])
    ])
  ], 8, _);
}
const D = /* @__PURE__ */ f(m, [["render", B]]);
export {
  D as default
};
